export const SlashDivider = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='952' height='2' viewBox='0 0 952 2' fill='none'>
    <path d='M0 1H952' stroke='#DFDFDF' strokeDasharray='4 4' />
  </svg>
);
